export default __webpack_public_path__ + "static/varjays-ja-leikkaus-6cbf78cd97aa76335dc74742556e4a4a.jpg";